import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { Multimodal } from '@/screens/Multimodal';

export default function ModeOptimizationPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="multimodal transport, multimodal shipping, "
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        title="Multimodal Transport and Shipping Services | Loadsmart"
        description="Work with a single vendor to execute your multimodal shipments. We leverage technology to help you lower cosst and improve flexibility from the port to the road."
        canonical="https://loadsmart.com/multimodal/"
        openGraph={{
          url: 'https://loadsmart.com/multimodal/',
        }}
      />
      <Multimodal />
    </>
  );
}
